<section>
    <span class="title">{{ groupLabel }}</span>
    <!-- the light-box closes the menu on any click - the switch keeps the menu open -->
    <div class="theme-switch" role="radiogroup" [attr.aria-label]="groupLabel" (click)="$event.stopPropagation()">
        @for (option of options; track option.value) {
            <button
                type="button"
                role="radio"
                [attr.aria-checked]="current() === option.value"
                [class.selected]="current() === option.value"
                (click)="select(option.value)"
            >
                <span class="mat-icon" aria-hidden="true">{{ option.icon }}</span>
                {{ option.label }}
            </button>
        }
    </div>
</section>
